import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssinaturaContratosService {

  finalizadosGet$ = new BehaviorSubject(null);
  abertosGet$ = new BehaviorSubject(null);
  contratoGet$ = new BehaviorSubject(null);
  sumarioGet$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  getFinalizados() {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Dashboard/finalizados/" + environment.empresa;

      this.http.get(url).subscribe({
        next: (data) => this.finalizadosGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.finalizadosGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.finalizadosGet$.unsubscribe(),
          this.finalizadosGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  getAbertos() {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Dashboard/assinaturas/" + environment.empresa;

      this.http.get(url).subscribe({
        next: (data) => this.abertosGet$.next(data),
        error: (error: HttpErrorResponse) => {
          this.abertosGet$.next(false);
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.abertosGet$.unsubscribe(),
          this.abertosGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  getContrato(id_contrato) {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Contratos/ObterComAssinatura/" + id_contrato + "/" + environment.empresa;

      this.http.get(url).subscribe({
        next: (data) => this.contratoGet$.next(data),
        error: (error: HttpErrorResponse) => {
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.contratoGet$.unsubscribe(),
        this.contratoGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }

  getContratoSumario(id_contrato) {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/Contratos/ObterSumarioDocumentoAssinadoChave/" + id_contrato + "/" + environment.empresa;

      this.http.get(url).subscribe({
        next: (data) => this.sumarioGet$.next(data),
        error: (error: HttpErrorResponse) => {
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.sumarioGet$.unsubscribe(),
        this.sumarioGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }
}
